import styled from 'styled-components';
import { HtmlZone } from '../common-components/HtmlZone';

export const GameHtmlZone = styled(HtmlZone)`
  position: absolute;
  top: 5vh;
  height: 15vh;
  right: 5vw;
  left: 5vw;
  display: flex;
  align-content: center;
  justify-content: center;
`;
GameHtmlZone.displayName = 'GameHtmlZone';

export const GameZone = styled.div`
  position: absolute;
  height: 80vh;
  bottom: 5vh;
  left: 3.3vw;
  right: 3.3vw;
`;
GameZone.displayName = 'GameZone';

export const VideoGameZone = styled.div`
  position: absolute;
  height: 96vh;
  bottom: 0;
  left: 0;
  right: 0;
`;
VideoGameZone.displayName = 'VideoGameZone';
